import { Admin, CreateAdminDto, UpdateAdminDto } from "@/types";
import { axiosInstance } from "@/lib/axios";

export interface GetAdminsParams {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
}

export interface GetAdminsResponse {
  data: Admin[];
  count: number;
}

/**
 * Get all admins with pagination
 */
export const getAdmins = async (
  params?: GetAdminsParams
): Promise<GetAdminsResponse> => {
  const response = await axiosInstance.get<GetAdminsResponse>(`/admins`, {
    params,
  });
  return response.data;
};

/**
 * Get a single admin by ID
 */
export const getAdminById = async (id: string): Promise<Admin> => {
  const response = await axiosInstance.get<Admin>(`/admins/${id}`);
  return response.data;
};

/**
 * Create a new admin
 */
export const createAdmin = async (
  data: CreateAdminDto
): Promise<{ message: string }> => {
  const response = await axiosInstance.post<{ message: string }>(
    "/admins/invite",
    data
  );
  return response.data;
};

/**
 * Update an existing admin
 */
export const updateAdmin = async (
  id: string,
  data: UpdateAdminDto
): Promise<Admin> => {
  const response = await axiosInstance.patch<Admin>(`/admins/${id}`, data);
  return response.data;
};

/**
 * Delete an admin
 */
export const deleteAdmin = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/admins/${id}`);
};

/**
 * Admin signup with token and password
 */
export const adminSignup = async (data: {
  token: string;
  password: string;
}): Promise<{ message: string }> => {
  const response = await axiosInstance.post<{ message: string }>(
    "/auth/admin/signup",
    data
  );
  return response.data;
};
